/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ note: NonNullable<unknown> }} Delivery_Board_CautionInputs */

const en_delivery_board_caution = /** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Caution: ${i?.note}. Verify rider costs.`)
};

const es_delivery_board_caution = /** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Precaución: ${i?.note}. Verifica los costos del repartidor.`)
};

const fr_delivery_board_caution = /** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attention : ${i?.note}. Vérifiez les frais de coursier.`)
};

const de_delivery_board_caution = /** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Achtung: ${i?.note}. Kurierkosten prüfen.`)
};

const id_delivery_board_caution = /** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perhatian: ${i?.note}. Verifikasi biaya kurir.`)
};

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const ja_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const zh_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const ar_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const it_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const ru_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const pt_delivery_board_caution = en_delivery_board_caution;

/** @type {(inputs: Delivery_Board_CautionInputs) => LocalizedString} */
const ko_delivery_board_caution = en_delivery_board_caution;

/**
* | output |
* | --- |
* | "Caution: {note}. Verify rider costs." |
*
* @param {Delivery_Board_CautionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_caution = /** @type {((inputs: Delivery_Board_CautionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_CautionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_caution(inputs)
	if (locale === "es") return es_delivery_board_caution(inputs)
	if (locale === "fr") return fr_delivery_board_caution(inputs)
	if (locale === "de") return de_delivery_board_caution(inputs)
	if (locale === "ja") return ja_delivery_board_caution(inputs)
	if (locale === "zh") return zh_delivery_board_caution(inputs)
	if (locale === "ar") return ar_delivery_board_caution(inputs)
	if (locale === "id") return id_delivery_board_caution(inputs)
	if (locale === "it") return it_delivery_board_caution(inputs)
	if (locale === "ru") return ru_delivery_board_caution(inputs)
	if (locale === "pt") return pt_delivery_board_caution(inputs)
	return ko_delivery_board_caution(inputs)
});